// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__P-3Ph","detailsBorder":"styles_detailsBorder__3Tmfq"};